<div class="container-fluid" xmlns="http://www.w3.org/1999/html">
  <div class="row" style="margin-top: 10px;padding: 2%;">
    <div class="col-12">
      <div class="col-12 tableDiv" style="padding-top: 0">
        <p-confirmDialog class="confirm-message" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
        <p-confirmDialog key="scanned-samples" class="confirm-message"></p-confirmDialog>
        <table class="sampleTable" aria-describedby="Unboxing Table"
               style="width: 100%; height: 100%; table-layout: fixed;margin-top: -1.7%;">
          <thead class="orderTableHeader">
          <tr>
            <th style="width: 30%;" scope="col">Order Information</th>
            <th style="width: 70%;" scope="col">Scanning</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="orderTableBody">
              <div>
                <div class="flex ui-inputgroup inputClass">
                  <label pButton class="theme-button label" label="Order number"></label>
                  <span pInputText id="orderNumber">{{selectedOrderDetails?.orderNumber}}</span>
                </div>
                <div class="flex ui-inputgroup inputClass">
                  <label pButton class="theme-button label" label="Customer"></label>
                  <span pInputText id="customerID">{{selectedOrderDetails?.customerName}}</span>
                </div>
                <div class="flex ui-inputgroup inputClass">
                  <label pButton class="theme-button label" label="# of samples"></label>
                  <span pInputText id="numberOfSamples">{{selectedOrderDetails?.sampleCount}}</span>
                </div>
                <div class="col-12 flex pb-0 inputClass">
                  <div class="ui-inputgroup inputClass col-6 p-0">
                    <label pButton class="theme-button label" label="GxP"></label>
                    <span class="ui-inputgroup-addon" id="hasGxp" class="gxp-Input" >
                      <i [ngClass]="selectedOrderDetails?.isGxp? 'pi pi pi-check success' : 'pi pi-minus'"
                        style="font-size: 20px; vertical-align: middle;"></i>
                    </span>
                  </div>
                  <div class="col-6 p-0">
                      <label *ngIf="selectedOrderDetails?.isGxp" class="m-0 font-bold text-danger " style="font-size: large;">GxP</label>
                  </div>
                </div>
                <div class="flex ui-inputgroup inputClass">
                  <label pButton class="theme-button noHover label" label="Comment"></label>
                  <span pInputText id="orderComment">
                    {{selectedOrderDetails?.orderComment}}
                  </span>
                </div>
                <div class="completeScanSamples">
                  <div>
                    <p-dropdown [style]="{'width':'20vh','border-radius': '5px'}" [options]="printerList" [(ngModel)]="selectedPrinter" placeholder="Select Printer"></p-dropdown>
                  </div>
                  <div>
                    <button pButton class="theme-button buttonsRound printButton p-2" type="button" [disabled]="isPrintDisabled()" (click)="printSamples()"
                            label="Print Barcodes">
                    </button>
                  </div>
                  <div>
                    <button pButton class="theme-button buttonsRound receiveButton p-2" type="button" label="Receive Samples"
                            (click)="receiveSamples()" [disabled]="samplesReceived || isSampleListEmpty() || scannedUnreceivedSampleCount == 0">
                    </button>
                  </div>
                </div>
              </div>
            </td>
            <td class="processingTableBody">
              <div class="col-12 flex" style="color:#1F89CE; height: 15px;">
                <div class="col-6 p-0">
                  <label class="m-0 font-bold counter-size">Unreceived Samples: {{scannedUnreceivedSampleCount}}/{{unreceivedSampleCount}}</label>
                </div>

                <div class="col-6 p-0">
                  <label class="m-0 font-bold counter-size received-sample-legend" >Received Samples: {{scannedReceivedSampleCount}}/{{receivedSampleCount}}</label>
                </div>
              </div>
              <div class="col-12 divider">
                <div>
                  <p-messages *ngIf="samplesReceived" class="ui-messages-success" severity="success" closable>
                    <ng-template pTemplate>
                      <span style="padding: 5px;" class="static-content-message">{{sampleReceivedMessage}}</span>
                    </ng-template>
                  </p-messages>
                </div>
                <div class="col-12 flex">
                  <div class="col-11">
                    <p-table [value]="scannedSampleList"
                    [(selection)]="selectedScannedSamples"
                    [scrollable]="true"
                    dataKey="barcode"
                    selectionMode="multiple"
                    scrollHeight="400%">
             <ng-template pTemplate="header">
               <tr class="text-center">
                 <th scope="col">
                   <div class="ui-inputgroup">
                     <input id="barcodeBox" type="text" pKeyFilter="alphanum"
                            placeholder="Sample Barcode"
                            style="width: 100%; padding: 5px"
                            [(ngModel)]="scannedSampleBarcode"
                            (keydown.enter)="scanSampleBarcode()"
                            [disabled] = "samplesReceived">
                   </div>
                 </th>
                 <th scope="col">
                   <div class="ui-inputgroup">
                     <input id="plateBarcodeScanBox" type="text" pKeyFilter="alphanum"
                            placeholder="Plate Barcode"
                            style="width: 100%; padding: 5px"
                            [(ngModel)]="scannedPlateBarcode"
                            (keydown.enter)="scanPlateBarcode()"
                            [disabled] = "samplesReceived">
                   </div>
                 </th>
                 <th scope="col"style="width: 16%">
                   Plate Position
                 </th>
                 <th scope="col" style="width: 10%">
                   Name
                 </th>
                 <th scope="col" style="width: 16%">
                  Library Type
                 </th>
                 <th scope="col" style="width: 10%">
                   Source
                 </th>
                 <th scope="col" style="width: 12%">
                   Extraction
                 </th>
               </tr>
             </ng-template>
             <ng-template pTemplate="body" let-sample let-rowIndex="rowIndex">
               <tr [pSelectableRow]="sample" class="text-center" [ngClass]="getCSSClassForReceivedSamples(sample.receptionDetails)"  [pSelectableRowIndex]="rowIndex">
                 <td>{{sample.barcode}} &nbsp;<label *ngIf="sample.gxp" class="m-0 text-danger font-weight-bold">GxP</label></td>
                 <td>{{sample.plateBarcode || 'N/A'}}</td>
                 <td>{{sample.platePosition || 'N/A'}}</td>
                 <td>{{sample.sampleNameCustomer}}</td>
                 <td>{{sample.libraryType}}</td>
                 <td>{{sample.sampleSource}}</td>
                 <td style="width: 12%">
                   <i [ngClass]="sample.extraction? 'pi pi pi-check success' : 'pi pi-minus'" style="font-size: 20px; vertical-align: middle;"></i>
                 </td>
               </tr>
             </ng-template>
           </p-table>
                  </div>
                <div class="col-1" style="padding-left: 5px; padding-top: 0">
                  <div>
                    <button pButton class="theme-button buttonsRound" type="button" label="Remove from list"
                            [disabled]="selectedScannedSamples == null || selectedScannedSamples == undefined || selectedScannedSamples.length == 0 || samplesReceived"
                            (click)="confirmSampleRemoval()"></button>
                  </div>
                  <div>
                    <button pButton class="theme-button buttonsRound" type="button" label="Sample Issue"
                            [disabled]="(selectedScannedSamples && selectedScannedSamples.length == 0 ) || samplesReceived"
                            (click)="editSample()"></button>
                  </div>
                </div>
              </div>
              </div>

            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Edit Sample" closable="true" modal="true"
          [(visible)]="showEditSampleDialog">
  <div class="col">
    <div class="col-12" style="text-align:left;font-weight:bold;">
      <div class="col-6">
        <div><h6><strong>Order ID:</strong>  {{selectedScannedSamples[0]?.orderNumber}}</h6></div>
        <div><h6><strong>Sample ID:</strong>  {{selectedScannedSamples[0]?.barcode}}</h6>
        </div>
      </div>
    </div>
    <div>
      <h6><strong>Sample Issues:</strong></h6>
      <div class="col-12 ui-md-12 ui-lg-12" *ngFor="let sampleIssue of sampleIssuesOptions">
        <p-radioButton name="sampleIssue"
                       [label]="sampleIssue.label"
                       [value]="sampleIssue.value"
                       [(ngModel)]="selectedSampleIssue">
        </p-radioButton>
      </div>
      <div>
        <div style="display:block"><strong>comments:  &nbsp;</strong></div>
        <textarea class="comment-textarea" pInputTextarea rows="6" cols="30" [(ngModel)]="selectedSampleComment"></textarea>
      </div>

    </div>
  </div>
  <p-footer>
    <button pButton type="button" label="Done" class="h-2rem" (click)="saveEditedSample()" ></button>
  </p-footer>
</p-dialog>

<p-dialog header="Receive Samples" closable="true" modal="true"
          [(visible)]="showReceiveSamplesDialog">
  <div class="col-12 " >
    <div class="ui-inputgroup dialogInputClass p-field" id="arrivalTempDropdown">
      <label pButton class="label" label="Arrival Temp."></label>
      <p-dropdown [style]="{'width':'300px'}" [options]="arrivalTempOptions" [(ngModel)]="selectedOrderArrivalTemp" showClear=true
                  placeholder="Select Arrival Temp" name="arrivalTemp" required></p-dropdown>
    </div>
    <div class="ui-inputgroup dialogInputClass p-field" id="storageTempDropdown">
      <label pButton class="label" label="Storage Temp."></label>
      <p-dropdown [style]="{'width':'300px'}" [options]="storageTempOptions" [(ngModel)]="selectedOrderStorageTemp" showClear=true
                  placeholder="Select Storage Temp" name="storageTemp" required></p-dropdown>
    </div>
    <div class="ui-inputgroup dialogInputClass p-field" id="storageLocationDropdown">
      <label pButton class="label" label="Storage Location"></label>
      <p-dropdown [style]="{'width':'300px'}" [options]="storageLocationsOptions" [(ngModel)]="selectedOrderStorageLocation" showClear=true
                  placeholder="Select Storage Location" name="storageLocation" required></p-dropdown>
    </div>
  </div>
  <div class="col-12">
    <h6><strong>If applicable: </strong></h6>
    <div class="ui-inputgroup dialogInputClass">
      <label pButton class="label" label="RGC Available"></label>
      <p-dropdown [style]="{'width':'300px'}" [options]="rgcSelectionOptions" [(ngModel)]="rgcAvailable"
                  name="rgcAvailable" placeholder="Select RGC Available"></p-dropdown>
    </div>
    <div class="ui-inputgroup dialogInputClass" id="orderIssues">
      <label pButton class="label" label="Order Issues"></label>
      <p-multiSelect [style]="{'width':'300px'}" [options]="orderIssuesOptions" [(ngModel)]="selectedOrderIssues"
                     defaultLabel="Select Order Issues" name="orderIssues" optionLabel="label" optionValue="value"></p-multiSelect>
    </div>
    <div class="ui-inputgroup dialogInputClass" id="receptionComment">
      <label pButton class="label" label="Order Comment"></label>
      <textarea pInputTextarea [(ngModel)]="newReceptionComment" placeholder="Enter comment here"
                [rows]="5" autoResize="true"></textarea>
    </div>
  </div>
  <p-footer>
    <button pButton class="h-2rem border-round" type="button" label="Receive Samples" (click)="saveSampleData()" [disabled]="sampleReceptionInformationFilled()"></button>
  </p-footer>
</p-dialog>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>


<p-dialog header="Cancelled Sample" closable="true" modal="true"
          [(visible)]="showCancelSamplesDialog"
          [contentStyle]="{'max-width':'600px'}">
  <div class="col-12 " >
    <div class="col" >
      {{cancellationErrorMessage}}
    </div>

  </div>
</p-dialog>
